import { ExternalLink } from "lucide-react";

/**
 * AdBanner Component
 * Placeholder for advertising banners on location pages
 * 
 * Sizes:
 * - leaderboard: 728x90 (desktop header/footer)
 * - rectangle: 300x250 (sidebar)
 * - banner: 468x60 (inline)
 * - mobile: 320x50 (mobile)
 */
export default function AdBanner({ 
  size = "leaderboard", 
  position = "top",
  className = "" 
}) {
  const sizeStyles = {
    leaderboard: "w-full max-w-[728px] h-[90px]",
    rectangle: "w-[300px] h-[250px]",
    banner: "w-full max-w-[468px] h-[60px]",
    mobile: "w-full max-w-[320px] h-[50px]",
    responsive: "w-full h-[100px] sm:h-[90px]"
  };

  return (
    <div 
      className={`mx-auto ${sizeStyles[size]} ${className}`}
      data-testid={`ad-banner-${position}`}
      data-ad-size={size}
      data-ad-position={position}
    >
      {/* Placeholder - Replace with actual ad code (Google AdSense, etc.) */}
      <div className="w-full h-full bg-gradient-to-r from-stone-100 to-stone-50 border border-dashed border-stone-300 rounded-lg flex flex-col items-center justify-center gap-1">
        <div className="flex items-center gap-1.5 text-stone-400">
          <ExternalLink className="w-4 h-4" />
          <span className="text-xs font-medium uppercase tracking-wide">Advertisement</span>
        </div>
        <span className="text-[10px] text-stone-300">
          {size === "leaderboard" && "728×90"}
          {size === "rectangle" && "300×250"}
          {size === "banner" && "468×60"}
          {size === "mobile" && "320×50"}
          {size === "responsive" && "Responsive"}
        </span>
      </div>
    </div>
  );
}

/**
 * Usage Instructions:
 * 
 * To replace with real ads, update the component to render actual ad code:
 * 
 * Example with Google AdSense:
 * <ins className="adsbygoogle"
 *   style={{ display: "block" }}
 *   data-ad-client="ca-pub-XXXXXXX"
 *   data-ad-slot="XXXXXXX"
 *   data-ad-format="auto"
 *   data-full-width-responsive="true"
 * />
 * 
 * Then call: (window.adsbygoogle = window.adsbygoogle || []).push({});
 */
